import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {contactMessageStateSchema} from './ContactMessageState';
import {contactMessageWriteSchema} from './contactMessageWriteSchema';

/** Document shape as stored in DB (id comes from Firestore document id when reading). */
export const contactMessageDbSchema = contactMessageWriteSchema.extend({
  state: contactMessageStateSchema,
  createdAt: firestoreTimestampSchema,
});

export interface ContactMessageDb extends z.infer<typeof contactMessageDbSchema> {}
